// The studio MAIN test build at app-main.pixomaticc.com (branch nvtech-main, OWNER-RULINGS 89517c3: "Same as staging test",
// so every value equals environment.nvtech-staging.ts except the six API bases, which are api-main/1..6). Copied from:
// The N.V Tech `staging` test build (ledger d9c3645 "test builds of both"; hosts b8c6276a; WhatsCRM stopgap 622b298).
// Every literal is a ruled stage value or identical to prod (coordinator A2). Sentry and GA are off (A5): an empty DSN
// leaves the SDK nothing to send to, and src/index.nvtech.html carries no GA tag. Checked by scripts/check-nvtech-build.mjs.
export const environment = {
  production: true,
  dev: false,
  bookingsBaseUrl: 'https://api-main.pixomaticc.com/6',
  eventsBaseUrl: 'https://api-main.pixomaticc.com/2',
  photosBaseUrl: 'https://api-main.pixomaticc.com/3',
  usersBaseUrl: 'https://api-main.pixomaticc.com/1',
  notificationsBaseUrl: 'https://api-main.pixomaticc.com/5',
  paymentsBaseUrl: 'https://api-main.pixomaticc.com/4',
  // The public pricing page on staging and main (OWNER-RULINGS 6885405; 9739646 "ourpixo.com/pricing for now"), as in
  // environment.nvtech-staging.ts ("Same as staging test", 89517c3). Checked by scripts/check-nvtech-build.mjs D10M and D11.
  billingPage: 'https://ourpixo.com/pricing',
  eventPhotoPrefix: 'EVNT',
  eventPhotosAudioPrefix: 'EVNTA',
  categoryPhotoMobilePrefix: 'CTGRM',
  categoryPhotoDesktopPrefix: 'CTGRD',
  categoryMediaMobilePrefix: 'CTGRMM',
  categoryMediaDesktopPrefix: 'CTGRMD',
  apiKey: '',
  sentryDsn: '',
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  // No Tawk.to chat widget in the test build (OWNER-RULINGS f8db3ef, "Off in the test build"). The only key prod lacks:
  // app.component.ts reads it with `'tawkChat' in environment`, so prod, staging and development keep Tawk unchanged.
  tawkChat: false,
};
